module.exports = __webpack_public_path__ + "img/IDS_login.3c0a1a4b.png";